import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Service} from '../../../../domain/model/common/service.class';
import {SectionService} from '../../../../domain/model/common/section-service.class';
import {CvModel} from './cv.model';

const CURRENT_USER_PATH = 'currentUser';

/**
 * Created by Rodrigo Quesada on 20/03/17.
 */
@Injectable()
export class CvDownloadSectionService extends SectionService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'cv');
    }

    currentUserCv(): Observable<CvModel | undefined> {
        return this.get(CvModel, CURRENT_USER_PATH);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/model/cv-download-section.service.ts